import { useMutation, useQueryClient } from '@tanstack/react-query';
import { WorkflowDto, WorkflowRequestDto } from 'src/api/FiretrolApiClient';
import { workflowApiClient } from 'src/api/FiretrolApiClientInstances';
import { invalidateFor } from 'src/api/queries/invalidationMap';
import { queryKeys } from 'src/api/queries/queryKeys';

export function useSaveWorkflowTemplate() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({
      templateId,
      request,
    }: {
      templateId: number;
      request: WorkflowRequestDto;
    }) => workflowApiClient.updateWorkflowTemplate(templateId, request),
    meta: { suppressErrorToast: true, errorContext: 'workflow template save' },
    onSuccess: (result: WorkflowDto) => {
      if (result.id != null) {
        qc.setQueryData(
          queryKeys.workflows.templateDetail(String(result.id)),
          result,
        );
      }
    },
    onSettled: () => invalidateFor('workflowTemplate.save', qc),
  });
}

export function useDeleteWorkflowTemplate() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (templateId: number) =>
      workflowApiClient.deleteWorkflow(templateId),
    meta: { successMessage: 'Workflow deleted' },
    onSettled: () => invalidateFor('workflowTemplate.save', qc),
  });
}
